import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class YearChangeTrackService {
  public yearChangeTrack: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  //     true
  constructor() {}
}
